import { useState ,useRef} from "react";
import { colorClasses } from "../../utils";
import Feedback from "../Feedback";
import ActionButtons from "../ActionButtons";
import correct from "../../assets/sounds/correct.wav"
import wrong from "../../assets/sounds/wrong.wav"
import retry from "../../assets/sounds/retry.wav"
import check from "../../assets/sounds/check.wav"
const ClickCycleColorsExercise = ({ exercise }) => {
  const interactiveCount = exercise.pattern.filter(p => p.type === 'interactive').length;
  const [state, setState] = useState(
    Array(interactiveCount).fill(
      exercise.pattern.find(p => p.type === 'interactive')?.colors[0] || 'white'
    )
  );
  const correctSound = useRef(new Audio(correct))
  const wrongSound = useRef(new Audio(wrong))
  const retrySound = useRef(new Audio(retry))
  const checkSound = useRef(new Audio(check))
  const [feedback, setFeedback] = useState(null);

  const handleClick = (index) => {
    const pattern = exercise.pattern.filter(p => p.type === 'interactive')[index];
    const currentColorIndex = pattern.colors.indexOf(state[index]);
    const nextColorIndex = (currentColorIndex + 1) % pattern.colors.length;
    const newState = [...state];
    newState[index] = pattern.colors[nextColorIndex];
    checkSound.current.currentTime = 0;
    checkSound.current.play();
    setState(newState);
    setFeedback(null);
  };

  const handleCheck = () => {
    const isCorrect = JSON.stringify(state) === JSON.stringify(exercise.correctAnswer);
    if(isCorrect){
        correctSound.current.currentTime = 0;
        correctSound.current.play()
    }else{
        wrongSound.current.currentTime = 0;
        wrongSound.current.play()
    }
    setFeedback({
      type: isCorrect ? 'success' : 'error',
      message: isCorrect ? exercise.successMessage : exercise.errorMessage
    });
  };

  const handleReset = () => {
       retrySound.current.currentTime = 0;
       retrySound.current.play()
    setState(Array(interactiveCount).fill(
      exercise.pattern.find(p => p.type === 'interactive')?.colors[0] || 'white'
    ));
    setFeedback(null);
  };

  return (
    <>
      <div 
        className="flex gap-2 sm:gap-3 my-3 sm:my-5 flex-wrap justify-center p-2 sm:p-4 rounded-xl sm:rounded-2xl"
        style={{ backgroundColor: exercise.backgroundColor || 'transparent' }}
      >
        {exercise.pattern.map((item, idx) => {
          if (item.type === 'static') {
            return (
              <div
                key={idx}
                className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-2xl sm:text-3xl transition-all ${
                  item.isCircle ? 'rounded-full' : 'rounded-lg'
                } ${item.color ? colorClasses[item.color] : ''} ${
                  item.color ? 'border-2 border-gray-300' : ''
                }`}
              >
                {item.emoji || ''}
              </div>
            );
          } else {
            const interactiveIndex = exercise.pattern.slice(0, idx).filter(p => p.type === 'interactive').length;
            const currentValue = state[interactiveIndex];
            
            return (
              <div
                key={idx}
                onClick={() => handleClick(interactiveIndex)}
                className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-2xl sm:text-3xl cursor-pointer transition-all hover:scale-110 ${
                  item.isCircle ? 'rounded-full' : 'rounded-lg'
                } ${colorClasses[currentValue]} border-2 sm:border-4 border-dashed border-gray-400`}
              >
                {item.emoji || ''}
              </div>
            );
          }
        })}
      </div>
      <ActionButtons onCheck={handleCheck} onReset={handleReset} />
      <Feedback feedback={feedback} />
    </>
  );
};

export default ClickCycleColorsExercise